var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUpRight = function SvgArrowUpRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.247 5c.416 0 .75.334.75.75v7.5c0 .415-.334.75-.75.75a.75.75 0 0 1-.75-.75V7.558L6.278 14.78a.75.75 0 0 1-1.06-1.06l7.22-7.219-5.69-.003a.75.75 0 0 1-.75-.75c0-.415.333-.75.75-.75z"
  })));
};
export default SvgArrowUpRight;